/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { connect } from 'react-redux'
import {
  getPeriod,
  getLoading,
  getAggregate,
  getAggregateCA,
  getContrib,
  getCAContrib,
} from '../selectors'
import { changePeriod, retrieveKpiContrib, retrieveKpiCAContrib } from '../actions'

import { InLineMonthRange } from 'analytics/component/MonthRange'
import { Button } from 'antd'
import ContribContent from './ContribContent'
import { GroupSelector } from 'analytics'

const ContribView = ({
  loading,
  period,
  retrieve,
  aggregate,
  contrib,
  display,
  changePeriod,
  kpi,
  // isCa,
}) => (
  <div>
    <div
      style={{ display: 'grid', gridTemplateColumns: '300px 250px 150px', gridColumnGap: '5px' }}
    >
      <InLineMonthRange value={period} onChange={changePeriod} />
      <GroupSelector style={{ marginRight: '.9rem', marginLeft: '.9rem' }} allowAll />
      <Button type="primary" loading={loading} onClick={retrieve}>
        Retrieve
      </Button>
    </div>
    <ContribContent aggregate={aggregate} contrib={contrib} display={display} kpi={kpi} />
  </div>
)
//

const mapStateToProps = (state, { isCa, kpi }) => ({
  period: getPeriod(state),
  loading: getLoading(state),
  aggregate: isCa ? getAggregateCA(kpi)(state) : getAggregate(kpi)(state),
  contrib: isCa ? getCAContrib(kpi)(state) : getContrib(kpi)(state),
})

const mapDispatchToProps = (dispatch, { isCa }) => ({
  retrieve: (...args) =>
    dispatch(isCa ? retrieveKpiCAContrib(...args) : retrieveKpiContrib(...args)),
  changePeriod: (...args) => dispatch(changePeriod(...args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ContribView)
